import { navSections } from '../config/navigation';

function itemAllowed(item, { role, hasPermission }) {
  if (item.roles?.length && !item.roles.includes(role)) return false;
  if (item.permission && !hasPermission(item.permission)) return false;
  return true;
}

/** Returns nav sections visible to the current user. */
export function getNavSectionsForUser({ role, hasPermission }) {
  return navSections
    .filter((section) => {
      if (section.roles?.length && !section.roles.includes(role)) return false;
      return true;
    })
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => itemAllowed(item, { role, hasPermission })),
    }))
    .filter((section) => section.items.length > 0);
}
